import { generate as r } from "./generate.js";
async function h({
  session: n,
  minSuggestions: t,
  maxSuggestions: s = 5,
  ...o
} = {}) {
  const e = n?.__statefulMessages.get() ?? [];
  try {
    return (await r(
      `Suggest what the user should say to AI to ${e.length > 0 ? "continue the conversation" : "start a new conversation"}. Provide clear, highly relevant suggestions. Do not literally suggest tool calls. Instead, suggest what the user should say to achieve their goal, that may result in tool calls. 
        ${t ? `Provide at least ${t} suggestions.` : "If you have no suggestions, return an empty array."}. Provide at most ${s} suggestions.`,
      {
        type: "array",
        items: {
          type: "object",
          properties: {
            label: {
              type: "string",
              description: "The label of the suggestion. This is shown as a button and should be short. Each label should be unique. It should be no more 5 words."
            },
            message: {
              type: "string",
              description: "The message to send when the suggestion is clicked. This should be a clear, complete sentence and will be sent as an instruction to the AI."
            }
          },
          required: ["label", "message"],
          additionalProperties: !1
        }
      },
      {
        ...o,
        context: [
          ...e.length > 0 ? [
            {
              description: "The last messages in the session",
              value: e.filter((l) => l.type !== "tool_call").slice(-2)
            }
          ] : [],
          ...o?.context || []
        ]
      }
    )).slice(0, s);
  } catch (a) {
    throw a;
  }
}
export {
  h as generateCopilotSuggestions
};
